module.exports = __webpack_public_path__ + "static/img/4.acaaef8d.png";